import { post, postSalesAddress, put, get } from "src/api/address.js";

import AddAddressForm from "src/modules/user/components/AddAddressForm.vue";

const getInitialState = () => ({
  address: {},
  addresses: [],
});

export const useAddressStore = defineStore("address", () => {
  const state = reactive(getInitialState());
  const route = useRoute();
  const { getUser, setPrimaryAddress } = useUserStore();

  const { state: addAddressFormState, toggle: toggleAddAddressForm } =
    useDrawer({
      component: AddAddressForm,
    });

  const primaryAddress = computed(() => {
    return state.addresses?.filter((item) => item.is_primary);
  });

  const otherAddresses = computed(() => {
    return state.addresses?.filter((item) => !item.is_primary);
  });

  const postAddress = async (payload) => {
    const { user } = storeToRefs(useUserStore());
    const userId = payload.user_id || unref(user)._id;
    const isUserRoute = route.name.includes("users");
    const response = isUserRoute
      ? await post(userId, payload)
      : await postSalesAddress(userId, payload);
    let addressResponse = response?.data?.data;

    if (addressResponse?.is_primary) {
      setPrimaryAddress(addressResponse);
    }

    await getUser(userId);

    return response;
  };

  const putAddress = async (payload) => {
    const { user } = storeToRefs(useUserStore());
    const response = await put(unref(user)._id, payload);
    let addressResponse = response?.data?.data;

    if (addressResponse?.is_primary) {
      setPrimaryAddress(addressResponse);
    }

    await getUser(unref(user)._id);

    return response;
  };

  const getAddress = async () => {
    const { user } = storeToRefs(useUserStore());
    const response = await get(unref(user)._id);

    state.addresses = response?.data?.data;

    return response;
  };

  return {
    ...toRefs(state),
    primaryAddress,
    otherAddresses,
    addAddressFormState,
    toggleAddAddressForm,
    postAddress,
    putAddress,
    getAddress,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAddressStore, import.meta.hot));
}
